import styled from 'styled-components';
import { FileSelector } from 'react-rainbow-components';

// eslint-disable-next-line import/prefer-default-export
export const SelectFile = styled(FileSelector)`
    margin: 64px 40px 72px 40px;
    height: 100%;
    width: auto;
`;
